import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import AuthAxios from "../../config/authAxios";
import apiRoutes from "../apiConfigs";

export const manageQuickAccessApi = createAsyncThunk(
    'quickAccess/list',
    async (data, { rejectWithValue }) => {
        try {
            const response = await AuthAxios.get(apiRoutes.quickAccessList,
                { params: data },
            );
            return response?.data;
        } catch (error) {
            return rejectWithValue(error?.response?.data);
        }
    }
);

const manageQuickAccessSlice = createSlice({
    name: 'quickAccess',
    initialState: { result: [], loading: false, error: null, message: "", total: 0 },
    reducers: {
        resetQuickAccess: (state) => {
            state.result = [];
            state.loading = false;
            state.error = null;
            state.message = "";
            state.total = 0;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(manageQuickAccessApi.pending, (state, action) => {
            state.loading = true;
        });
        builder.addCase(manageQuickAccessApi.fulfilled, (state, action) => {
            state.loading = false;
            state.result = action?.payload?.result;
            state.message = action?.payload?.message;
            state.total = action?.payload?.count;
        });
        builder.addCase(manageQuickAccessApi.rejected, (state, action) => {
            state.loading = false;
            state.error = action?.payload?.error;
            state.message = action?.payload?.message;
        });
    },
});

export const { resetQuickAccess } = manageQuickAccessSlice.actions;
export const manageQuickAccessReducer = manageQuickAccessSlice.reducer;
